import React from "react";
import PropTypes from "prop-types";
import Separator from "../../core/Separator";
import CertificationTestResultDetailItem from "./CertificationTestResultDetailItem";
import TranslatedText from "../../core/TranslatedText";

const CertificationTestResultDetail = (props) => (
  <div>
    <TranslatedText
      as="p"
      translateKey={
        props.certificationTest.approvedAt
          ? "certificationTest.result.approvedDescriptionTwo"
          : "certificationTest.result.failedDescriptionTwo"
      }
      values={{
        unitsCount: props.unitsToFinishAfterCertificationTestFailure,
      }}
      style={{
        margin: 0,
        color: "#757575",
        fontSize: 13,
      }}
    />
    <Separator size="md" />
    <Separator size="xs" />
    <TranslatedText
      as="h5"
      translateKey="certificationTest.result.scoreBySkill"
      style={{
        margin: 0,
        fontSize: 14,
        fontWeight: "bold",
        color: "#757575",
      }}
    />
    <Separator />
    <CertificationTestResultDetailItem value={props.certificationTest.readingScore} type="reading" />
    <Separator size="xs" />
    <CertificationTestResultDetailItem value={props.certificationTest.listeningScore} type="listening" />
    <Separator size="xs" />
    <CertificationTestResultDetailItem value={props.certificationTest.writingScore} type="writing" />
    <Separator size="xs" />
    <CertificationTestResultDetailItem value={props.certificationTest.speakingScore} type="speaking" />
    <Separator size="md" />
    <Separator size="xs" />
    <TranslatedText
      as="h5"
      translateKey="certificationTest.result.finalScore"
      style={{
        margin: 0,
        fontSize: 14,
        fontWeight: "bold",
        color: "#757575",
      }}
    />
    <Separator size="md" />
    <h1
      style={{
        margin: 0,
        fontSize: 120,
        fontWeight: "bold",
        color: props.certificationTest.approvedAt ? "#00786A" : "#546e7a",
        lineHeight: "85px",
      }}
    >
      {(
        ((props.certificationTest.readingScore || 0) +
          (props.certificationTest.listeningScore || 0) +
          (props.certificationTest.writingScore || 0) +
          (props.certificationTest.speakingScore || 0)) /
        4
      ).toFixed(0)}
    </h1>
    <Separator size="md" />
    <Separator size="sm" />
  </div>
);

CertificationTestResultDetail.propTypes = {
  certificationTest: PropTypes.shape({
    approvedAt: PropTypes.string,
    course: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    readingScore: PropTypes.number,
    listeningScore: PropTypes.number,
    writingScore: PropTypes.number,
    speakingScore: PropTypes.number,
  }).isRequired,
  unitsToFinishAfterCertificationTestFailure: PropTypes.number.isRequired,
  nextCourse: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

CertificationTestResultDetail.defaultProps = {
  nextCourse: null,
};

export default CertificationTestResultDetail;
